/** IMO ship identification numbers.
 *
 * Seven digits, the last a check digit: the sum of the first six digits,
 * each multiplied by its weight (7 down to 2), modulo 10. A hull keeps its
 * number through every rename and re-flag, so it is a vessel's identity
 * anchor everywhere on the platform. Mirrors `vNext-api/vnext/core/imo.py`,
 * which re-validates on the server.
 */

const WEIGHTS = [7, 6, 5, 4, 3, 2];

/** The seven digits of an IMO number, or null.
 *
 * Keeps only the digits of "9116412", "IMO 9116412", "IMO: 9116412" or
 * "9 116 412", and reads the "9116412.0" a spreadsheet exports as the whole
 * number. Anything with more or fewer than seven digits left is not an IMO.
 */
export function normaliseImo(raw: string | number | null | undefined): string | null {
  if (raw === null || raw === undefined) {
    return null;
  }
  const text = String(raw).replace(/^\s*(\d+)\.0+\s*$/, '$1');
  const digits = text.replaceAll(/\D/g, '');
  return digits.length === 7 ? digits : null;
}

/** Whether a normalised, seven-digit IMO number's check digit is right. */
export function imoCheckDigitOk(imo: string): boolean {
  if (!/^\d{7}$/.test(imo)) {
    return false;
  }
  const total = WEIGHTS.reduce((sum, weight, i) => sum + Number(imo[i]) * weight, 0);
  return total % 10 === Number(imo[6]);
}
